import { render, staticRenderFns } from "./ladderSetting.vue?vue&type=template&id=700cc1d6&"
import script from "./ladderSetting.vue?vue&type=script&lang=js&"
export * from "./ladderSetting.vue?vue&type=script&lang=js&"
import style0 from "./ladderSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports